import { createContext } from "react";
import type { ObjectClassDefinition } from "../../../api/types/objectTypes";

interface ObjectsListContextValue {
  objectClassDefinition: ObjectClassDefinition;
  refreshRows: () => void;
  refreshObjects: () => void;
}

const ObjectsListContext = createContext<ObjectsListContextValue | undefined>(undefined);

export default ObjectsListContext;
